import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { loadMyWorkflowsRequest, loadMyWorkflowsRequestFailed, loadMyWorkflowsRequestSuccess } from "../../actions/workflows/my-workflows-request.action";
import { catchError, map, mergeMap } from "rxjs";
import { WorkflowRequestService } from "src/app/services/worflows-request/workflow-request.service";
import { parseFrontEndObjectProperties } from "src/app/models/workflow-request.model";

@Injectable()
export class MyWorkflowsRequestsEffects {
	private actions$ = inject(Actions);
	private workflowRequestService = inject(WorkflowRequestService);


	// Load the workflows from backend
	loadMyWorkflowsRequest$ = createEffect(() => this.actions$.pipe(
		ofType(loadMyWorkflowsRequest),
		mergeMap(() =>
			this.workflowRequestService.loadMyWorkflowsRequests().pipe(
				map(resp => {
					if (resp.data) {
						resp.data.forEach(worflow => {
							return parseFrontEndObjectProperties(worflow);
						})
					}
					return loadMyWorkflowsRequestSuccess({ workflowsRequest: resp.data });
				}),
				catchError(async (error) => loadMyWorkflowsRequestFailed({ error: error })),
			)
		)
	));
}
